import { render } from "./DbsBookingBottomButton.vue?vue&type=template&id=d54bc2a4&scoped=true"
import script from "./DbsBookingBottomButton.vue?vue&type=script&lang=js"
export * from "./DbsBookingBottomButton.vue?vue&type=script&lang=js"

import "./DbsBookingBottomButton.vue?vue&type=style&index=0&id=d54bc2a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d54bc2a4"

export default script